export const WHITE_LABELS = [
  'skytech',
  'mobit',
  'elkjop',
  'bechtle',
  'arp',
  'csi',
  'control', // for backward compatibility
] as const
